export default "__VITE_PUBLIC_ASSET__5d3da97a__"